import { createContext, useContext } from 'react';
import { GearLoaderKey } from '../../Model/enums/GearLoaderKey';

interface ILoaderContext {
  showLoader: (isVisible: boolean, lockKey: GearLoaderKey) => void;
  clearAllLoaders: () => void;
}

export const LoaderContext = createContext<ILoaderContext>({
  showLoader: () => {},
  clearAllLoaders: () => {}
});

export const useLoaderContext = () => useContext(LoaderContext);
